import { render } from "./BBA.vue?vue&type=template&id=2fc0932f"
import script from "./BBA.vue?vue&type=script&lang=js"
export * from "./BBA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__